import type { FilterConfig } from '#types/config/components/filter'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    selected: 'bg-black',
  }
} satisfies RecursivePartial<FilterConfig['option']['tileSquare']>
